<div class="d-flex flex-column">
    <div class="d-flex flex-row gap-1 pe-3 py-2 align-items-center">
        <button adaptButtonIcon="fa fa-list"
                class="btn btn-blank"
                id="conversation-menu-button"
                [disabled]="isConversationPopoverVisible"
                adaptTooltip="Show past conversations"
                (click)="isConversationPopoverVisible = true"></button>
        @let swatchTheme = (chatAiUiService.chatLocationMode$ | async) === ChatLocationMode.Sidebar ? themeService.currentThemeSwatch : null;
        <!-- need the d-none for this or it will cause a gap in the row when popover visible -->
        <dx-popover target="#conversation-menu-button"
                    class="d-none"
                    [wrapperAttr]="{ class: 'conversation-wrapper', 'data-bs-theme': swatchTheme }"
                    [visible]="isConversationPopoverVisible"
                    [hideOnOutsideClick]="true"
                    [showCloseButton]="true"
                    [width]="360"
                    [position]="{ of: '#conversation-menu-button', my: 'left top', at: 'left bottom', offset: '0 -10' }"
                    (onHidden)="isConversationPopoverVisible = false"
                    (onShowing)="refreshConversationList()">
            <div *dxTemplate="let data of 'content'"
                 class="conversation-popover">
                <adapt-conversation-list [currentConversationId]="chat.conversationId"
                                         [swatchTheme]="swatchTheme"
                                         (conversationSwitched)="onConversationSwitched($event)"
                                         (conversationDeleted)="updateLatestConversation()"></adapt-conversation-list>
            </div>
        </dx-popover>
        <button adaptButton="addBorderless"
                class="flex-shrink-0"
                (click)="createNewChat($event)">New chat</button>
        @if ((chatAiUiService.chatLocationMode$ | async) === ChatLocationMode.Sidebar) {
            <button class="ms-auto btn btn-blank"
                    adaptButtonIcon="fal fa-chevron-right"
                    data-test="move-to-dialog-button"
                    (click)="moveChatToDialog()">Move to dialog</button>
        } @else if (shellUiService.controlShiftHeld$ | async) {
            <span class="text-muted ms-auto">Total cost: ${{ totalCost.toFixed(4) }}</span>
        }
    </div>

    <dx-chat class="chat"
             [class.chat-disabled]="chat.isDisabled || isStreaming"
             [class.chat-streaming]="isStreaming"
             [dataSource]="chat.dataSource"
             [reloadOnChange]="false"
             [showAvatar]="showAvatar"
             [showUserName]="true"
             [showDayHeaders]="false"
             [user]="user"
             height="100%"
             [alerts]="alerts$ | async"
             (onMessageEntered)="onMessageEntered($event)"
             (onAttachmentDownloadClick)="onAttachmentDownloadClick($event)"
             emptyViewTemplate="emptyViewTemplate"
             messageTemplate="messageTemplate">
        <dxo-chat-file-uploader-options [accept]="AcceptedChatFileTypes"
                                        [allowedFileExtensions]="AllowedChatFileExtensions"
                                        [uploadFile]="uploadFile"
                                        [onValueChanged]="onAttachmentValueChanged"></dxo-chat-file-uploader-options>
        <div *dxTemplate="let data of 'emptyViewTemplate'"
             class="d-flex flex-column gap-3">
            <div class="d-flex flex-column">
                <div class="d-flex justify-content-center">
                    <i class="empty-view-icon fal fa-comment-captions fa-2x"></i>
                </div>
                <h2 class="empty-view-title">There are no messages in this chat</h2>
                <div class="empty-view-subtitle">The Lumia Assistant is ready to answer your questions.</div>
            </div>
            @if (applicableMegaPrompts.length > 0) {
                <div class="d-flex flex-column gap-2">
                    <span class="prompt-option-title small text-muted">Or select one of the preset prompt(s) relevant to this
                        page</span>
                    <div class="d-flex flex-row flex-wrap justify-content-center gap-2">
                        @for (prompt of applicableMegaPrompts; track prompt.promptName) {
                            <div class="prompt-option"
                                 role="button"
                                 (click)="executeMegaPrompt(prompt)">{{ prompt.label }}</div>
                        }
                    </div>
                </div>
            }

            @if (latestConversation) {
                <span class="prompt-option-title">
                    <button adaptButtonIcon="fal fa-fw fa-bounce fa-repeat"
                            class="btn btn-link"
                            (click)="restoreLatestConversation()">Restore previous conversation</button></span>
            }
        </div>
        <div *dxTemplate="let data of 'messageTemplate'">
            @let isAssistantMessage = data.message.author.id !== user.id;
            @if (data.message.progressType) {
                <div class="chat-messagebubble-text">
                    <div class="d-flex flex-row gap-1 align-items-center">
                        <dx-load-indicator height="20"
                                           width="20"></dx-load-indicator>
                        {{ data.message.text }}
                    </div>
                    @if (data.message.subtext) {
                        <div class="subtext">{{ data.message.subtext }}</div>
                    }
                </div>
            } @else {
                <div class="chat-messagebubble-text"
                     [ngClass]="!isAssistantMessage && data.message.isHistorical ? 'historical-indicator' : null">
                    @if (!data.message.completed) {
                        <div class="d-flex flex-row gap-1 align-items-center">
                            <dx-load-indicator height="20"
                                               width="20"></dx-load-indicator>
                            <span class="small">Streaming response...</span>
                        </div>
                    }

                    @if (data.message.isMegaPrompt) {
                        <span class="small text-muted">Execute preset prompt</span>
                        <div class="mega-prompt-text">{{ data.message.renderedMessage }}</div>
                    } @else {
                        <div [class.markdown-body]="isAssistantMessage"
                             [froalaView]="data.message.renderedMessage ?? convertToHtml(data.message)"></div>
                    }

                    @if (data.message.isInterrupted) {
                        <div class="interrupted-message">
                            <i class="far fa-circle-exclamation"></i>
                            <span>Aborted</span>
                        </div>
                    }
                </div>
            }
            @if (data.message.completed && isAssistantMessage) {
                <div class="bubble-button-container">
                    <dx-button [icon]="data.message.isCopied ? CopiedButtonIcon : CopyButtonIcon"
                               stylingMode="text"
                               hint="Copy"
                               (onClick)="onCopyButtonClick(data.message)"></dx-button>
                </div>
            }
        </div>
    </dx-chat>
</div>
